import script from "./FilterBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBox.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__